import gql from "graphql-tag";

export default gql`
  mutation($productId: ID!, $printFiles: [OrderPersonalizedPrintFileInput!]) {
    bulkUploadPersonalizedPrintFiles(
      productId: $productId
      printFiles: $printFiles
    )
  }
`;
